module.exports = __webpack_public_path__ + "img/ch09_11_镜前.07a89715.jpg";